import { Worker, WorkerPosition } from "../../Models/Worker";

const mapToWorker = (worker: any): Worker => ({
  id: worker.id,
  name: worker.first_name,
  lastName: worker.last_name,
  nickName: worker.nick_name,
  positions: worker.worker_positions.map(mapToWorkerPosition),
});

const mapToWorkerPosition = (pos: any): WorkerPosition => ({
  id: pos.id,
  title: pos.title,
});

export default {
  worker: {
    mapToWorker,
  },
  workerPosition: {
    mapToWorkerPosition,
  },
};
